import { render, staticRenderFns } from "./typesOfPractice.vue?vue&type=template&id=755ff7c8&scoped=true"
import script from "./typesOfPractice.vue?vue&type=script&lang=js"
export * from "./typesOfPractice.vue?vue&type=script&lang=js"
import style0 from "./typesOfPractice.vue?vue&type=style&index=0&id=755ff7c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755ff7c8",
  null
  
)

export default component.exports